import { Add, remove } from "./actionCreator";
import { ADD, DELETE } from "./actionType";

const initialState = {
  info: [
    {
      id: 1,
      from: "Dhaka",
      to: "sylhet",
      date: "11-01-23",
      guests: "2",
      class: "Bussiness",
    },
    {
      id: 2,
      from: "Dhaka",
      to: "Sylhet",
      date: "11-01-23",
      guests: "1",
      class: "Economics",
    },
  ],
};

function infoReducer(state = initialState, action) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        info: [...state.info, action.payload],
      };
    case DELETE:
      return {
        ...state,
        info: state.info.filter((data) => data.id !== action.payload.id),
      };
    default:
      return state;
  }
}

export default infoReducer;
